import { ReportDisplayStatus } from 'api/candidates/types/Report';

const isActionRequired = (report: {
  displayStatus: ReportDisplayStatus | null;
  exceptions: any[];
}) => report.displayStatus === 'actionRequired';

export default isActionRequired;
